import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Container, Nav } from "react-bootstrap";
import "./Nav.css";
import { useAppContext } from "../Context/AppContext";

const NavBar = ({ category, categoryLogo, categoryId }) => {
  const { headerLogo } = useAppContext();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  // Check if current path matches hidden routes
  const isHiddenRoute = () => {
    const hiddenRoutePatterns = [/^\/category\/[a-z0-9]+$/, /^\/view\/[a-z0-9]+$/];
    return hiddenRoutePatterns.some((pattern) => pattern.test(location.pathname));
  };
  const hidden = isHiddenRoute() || categoryLogo || category;

  return (
    <div
      className="bg-white shadow-sm"
      style={{
        width: "95%",
        position: "fixed",
        top: 0,
        zIndex: 30,
        left: 0,
        right: 0,
        margin: "0 auto",
      }}
    >
      <Container>
        <Navbar className="navbar-expand-sm d-flex flex-wrap">
          <Nav.Link
            as={Link}
            to="/"
            className={`text-decoration-none pe-3 ${isActive("/") ? "text-warning" : "text-dark"}`}
            style={{
              textShadow: "1px 1px 1px black",
              cursor: hidden ? "not-allowed" : "pointer",
            }}
          >
            <div>
              {headerLogo ? (
                <img
                  src={headerLogo}
                  alt="Logo"
                  className="img-fluid"
                  style={{ height: "51px" }}
                />
              ) : (
                "Home"
              )}
            </div>
          </Nav.Link>

          {!hidden && (
            <Nav className="me-auto d-flex flex-wrap">
              <Nav.Link as={Link} to="/videos">
                <div
                  className={`text-decoration-none ${
                    isActive("/videos") ? "text-warning" : "text-dark"
                  }`}
                  style={{ textShadow: "1px 1px 1px black" }}
                >
                  Videos
                </div>
              </Nav.Link>
            </Nav>
          )}

          {categoryLogo && (
            <span
              className="d-flex justify-content-end"
              style={{
                position: "absolute",
                top: "2",
                right: "0",
              }}
            >
              <Link to={`/${categoryId}`}>
                <img
                  src={categoryLogo}
                  alt="Category Logo"
                  style={{
                    maxWidth: "10rem",
                    maxHeight: "3rem",
                    borderRadius: "10%",
                    cursor: "pointer",
                    transition: "transform 0.2s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                  onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                />
              </Link>
            </span>
          )}
        </Navbar>
      </Container>
    </div>
  );
};

export default NavBar;
